import { usersApi } from '@frontend/lib/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useUsers() {
  const queryClient = useQueryClient();

  const listQuery = useQuery({
    queryKey: ['users'],
    queryFn: () => usersApi.list(),
  });

  const addMutation = useMutation({
    mutationFn: (data: { email: string; role?: 'admin' | 'user' }) =>
      usersApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });

  const updateRoleMutation = useMutation({
    mutationFn: (data: { email: string; role: 'admin' | 'user' }) =>
      usersApi.updateRole(data.email, data.role),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });

  const removeMutation = useMutation({
    mutationFn: (email: string) => usersApi.delete(email),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });

  return {
    users: listQuery.data?.users ?? [],
    isLoading: listQuery.isLoading,
    addUser: addMutation.mutateAsync,
    isAdding: addMutation.isPending,
    addError: addMutation.error,
    updateRole: updateRoleMutation.mutateAsync,
    isUpdatingRole: updateRoleMutation.isPending,
    updateRoleError: updateRoleMutation.error,
    removeUser: removeMutation.mutateAsync,
    isRemoving: removeMutation.isPending,
  };
}
